"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Executes all enqueued functions sequentially.
 */
var createProcessingStack = exports.createProcessingStack = function createProcessingStack() {
  var processingStack = Promise.resolve();
  return function (callback) {
    return processingStack.then(callback);
  };
};